import script from "./PopupeditDomainSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupeditDomainSettings.vue?vue&type=script&setup=true&lang=js"

import "./PopupeditDomainSettings.vue?vue&type=style&index=0&id=8a395c64&lang=css"

const __exports__ = script;

export default __exports__
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinnerOrbit from 'quasar/src/components/spinner/QSpinnerOrbit.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSkeleton,QBtn,QInput,QSelect,QInnerLoading,QSpinnerOrbit});
